/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_LIVESFEAST = 20;

Mission.REGISTRATIONS.set(Mission.TYPE_LIVESFEAST, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.LIVESFEAST_MISSION,
    disabledNewMission: ["mergecraft", "fairy", "hustlemerge", "wondermerge"].includes(cleverapps.config.name),
    name: "LivesFeast",
    duration: "3 day",
    semaphore: Mission.SEMAPHORE_PRIMARY,
    competition: {
        step: [3, 3, 3, 5, 5, 5, 10, 10, 15, 20, 25],
        forceCoef: 0.45,
        amount: [20, 30],
        noPlayerEpisodeCoef: true,
        botAheadPlayerCoef: 0.5,
        botAheadPlayerBigDifferenceCoef: 0.2,
        bigDistanceLength: 100
    },
    logic: LivesFeast,
    prize: RewardsConfig.LivesFeast.places,
    bundle: "lives_feast",
    collectIcon: function () {
        return cleverapps.skins.getSlot("reward_energy_png") || bundles.reward_icons.frames.reward_energy_png;
    },
    sideBarJson: bundles.sidebar.jsons.lives_feast_icon_json,
    view: LivesFeastMissionWindow,
    startWindow: LivesFeastMissionWindow,
    guideWindow: {
        name: "LivesFeastGuideWindow",
        bundle: bundles.livesfeastguidewindow,
        title: "LivesFeastGuideWindow.title"
    },
    finishWindow: LivesFeastMissionWindow
}));
